/* eslint-disable prettier/prettier */
const actions = {
  async listPaymentToInsurerRequest(context, payload) {
    try {
      const fetchParameters = {
        params: {
          insurerCode: context.getters["getSelectedInsurer"]?.code || "ALL",
        },
        ...payload,
      };
      const response = await this.$api.call(
        "finops_payment_to_insurer_request.list",
        fetchParameters,
      );
      if (response.data === null) {
        response.data = [];
      }
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPaymentToInsurerRequestList", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPaymentToInsurerRequestList", responseData);
      }

      context.commit("mutationFetchParameter", fetchParameters);
      context.commit("mutationPaymentToInsurerRequestMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPaymentToInsurerRequestList", []);
      context.commit("mutationPaymentToInsurerRequestMeta", {});

      throw error;
    }
  },

  async listInsurerBranch(context, payload) {
    try {
      const response = await this.$api.call(
        "finops_payment_to_insurer_request.insurance_branch_list",
        payload,
      );

      if (response.data === null) {
        response.data = [];
      }

      const responseData = response.data;

      context.commit("mutationInsurerBranchList", responseData);

      return responseData;
    } catch (error) {
      context.commit("mutationInsurerBranchList", []);

      throw error;
    }
  },

  setSelectedInsurer(context, payload = "ALL") {
    context.commit("mutationSelectedInsurer", payload || { code: "ALL" });
  },

  setFetchParameter(context, payload = {}) {
    context.commit("mutationFetchParameter", payload || {});
  },

  async downloadListPaymentToInsurerRequest(context) {
    try {
      const fetchParameters = context.getters["getFetchParameter"];
      const response = await this.$api.call(
        "finops_payment_to_insurer_request.download",
        fetchParameters,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  async fetchRequestSummary(context) {
    try {
      const fetchParameters = context.getters["getFetchParameter"];
      const response = await this.$api.call(
        "finops_payment_to_insurer_request.request_summary",
        fetchParameters,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  async requestPaymentToInsurer(context) {
     try {
       const fetchParameters = {...context.getters["getFetchParameter"]};

       const insurerCode = fetchParameters?.params?.insurerCode;

       delete fetchParameters.query.limit;
       delete fetchParameters.query.page;

       if (fetchParameters.query?.filter?.is_insurance_branch_ho) {
         fetchParameters.query.filter.is_insurance_branch_ho = "true";
       } else {
         fetchParameters.query.filter.is_insurance_branch_ho = "false";
       }

       const response = await this.$api.call(
         "finops_payment_to_insurer_request.request_payment",
         {
           params: {
             insurerCode: insurerCode,
           },
           data: fetchParameters.query
         },
       );

       return response;
     } catch (error) {
       throw error;
     }
  }
};

export default actions;
